







































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { IAgency, IPolicy } from 'admiral-core';
import dayjs from 'dayjs';

interface ProductSummary {
  id: string;
  name: string;
  count: number;
  value: number;
}

@Component({})
export default class TopProductsCard extends Vue {
  @Prop({ type: String, required: true }) title!: string;
  @Prop({ type: String, required: true }) subtitle!: string;
  @Prop({ type: Array, required: true }) policies!: IPolicy[];
  @Prop({ type: Object, required: false }) agency!: IAgency;

  activeTab: 'new' | 'policed' = 'new';
  currentMetric: 'count' | 'value' = 'count';
  isDropdownOpen = false;

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectMetric(metric: 'count' | 'value') {
    this.currentMetric = metric;
    this.isDropdownOpen = false;
  }

  get topNewProducts(): ProductSummary[] {
    return this.getTopProducts('new');
  }

  get topPolicedProducts(): ProductSummary[] {
    return this.getTopProducts('policed');
  }

  get currentProducts(): ProductSummary[] {
    return this.activeTab === 'new' ? this.topNewProducts : this.topPolicedProducts;
  }

  getTopProducts(type: 'new' | 'policed'): ProductSummary[] {
    const thirtyDaysAgo = dayjs().subtract(30, 'day').startOf('day');

    // Filter policies based on type
    const filteredPolicies = this.policies.filter((policy) => {
      if (type === 'new') {
        return dayjs(policy.createdAt).isAfter(thirtyDaysAgo);
      } else {
        return policy.policedAt && dayjs(policy.policedAt).isAfter(thirtyDaysAgo);
      }
    });

    // Group by product
    const productMap = new Map<string, ProductSummary>();

    filteredPolicies.forEach((policy) => {
      if (!policy.product) {
        return;
      }
      const productId = policy.product.id;
      const productName = policy.product.name;

      if (!productMap.has(productId)) {
        productMap.set(productId, {
          id: productId,
          name: productName,
          count: 0,
          value: 0,
        });
      }

      const product = productMap.get(productId)!;
      product.count += policy.quantity || 0;
      product.value += policy.value || 0;
    });

    // Convert to array
    const productsArray = Array.from(productMap.values());

    // Sort by the current metric and take top 7
    return this.currentMetric === 'count'
      ? productsArray.sort((a, b) => b.count - a.count).slice(0, 7)
      : productsArray.sort((a, b) => b.value - a.value).slice(0, 7);
  }

  formatValue(product: ProductSummary): string {
    if (this.currentMetric === 'count') {
      return `${product.count} Stk.`;
    } else {
      return `${product.value.toLocaleString('de-DE')}`;
    }
  }
}
